<script setup lang="ts">
defineProps<{
  icon?: string;
  title?: string;
  message?: string;
}>();
</script>

<template>
  <div
    class="pa-4 d-flex flex-column justify-space-around align-center text-center fill-height wrapper">
    <div>
      <v-icon size="100px">{{ icon || 'mdi-alert-circle' }}</v-icon>
      <p class="title typography-heading-lg-bold">{{ title || 'Unable to check in' }}</p>
      <p class="typography-body-md">
        {{
          message ||
          'Please confirm the information with your dispatcher or reach out to the warehouse'
        }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  color: #1e3036;
}

.title {
  margin-top: 28px;
  margin-bottom: 20px;
}
</style>
